@if (dto) {
  <div class="header">
    <app-user-avatar-circle class="avatar" [fullName]="dto.FirstName + ' ' + dto.LastName"></app-user-avatar-circle>
    <div class="agreement-details-container">
      <h3 class="header__name">{{ dto.FirstName }} {{ dto.LastName }}</h3>
      <span class="header__details_row">
        <span class="name">{{ 'EDocumentDetails.Pesel' | translate }}: </span>{{ dto.Pesel }}
      </span>
      <span class="header__details_row">
        <span class="name"> {{ 'EDocumentDetails.Company' | translate }}: </span>{{ dto.CompanyName }}
      </span>
      <span class="header__details_row"> <span class="name">Status teczki: </span>Niekompletna </span>
    </div>
    <div class="paycheck-container">
      <div class="paycheck-item">
        <span class="name">Stanowisko</span>
        <span class="value">Księgowa</span>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="content-wrapper">
      <ng-container [ngTemplateOutlet]="fileContentsTable" [ngTemplateOutletContext]="{ contents: validationResult$ | async }"> </ng-container>
    </div>
  </div>
  <div class="footer">
    <button mat-raised-button color="primary" mat-dialog-close>{{ 'settlement-details.close' | translate }}</button>
  </div>
}

<ng-template #fileContentsTable let-contents="contents">
  <mat-table #table class="settlement-table table custom-table" [dataSource]="contents">
    <ng-container matColumnDef="part">
      <mat-header-cell *matHeaderCellDef class="hidden-sort"> Część </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{ disabled: !element.IsActive }">{{ element.Part }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="document">
      <mat-header-cell *matHeaderCellDef class="hidden-sort"> Dokument </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{ disabled: !element.IsActive }">
        <div>
          @for (item of element?.Documents; track item) {
            <div class="nested-row">
              @if (item.Doc) {
                <a class="user" (click)="onPreviewBtnClick(item.Doc)">{{ item.DocumentName }} </a>
              }
              @if (!item.Doc) {
                <span>{{ item.DocumentName }}</span>
              }
            </div>
          }
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="validationResult">
      <mat-header-cell *matHeaderCellDef class="hidden-sort"> Status weryfikacji </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="{ disabled: !element.IsActive }">
        <div class="nested-table">
          @for (item of element?.Documents; track item) {
            <div
              class="nested-row"
              [ngClass]="{ 'not-valid': item.ValidationResult.includes('brak'), valid: item.ValidationResult.includes('poprawny') }"
              >
              <span>{{ item.ValidationResult }}</span>
            </div>
          }
        </div>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</ng-template>
